import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { getprofile } from './slices/user';

import { useDispatch, useSelector } from "react-redux";
// import { useEffect } from 'react';


function SmoothScroll({ children }) {
    
    // useEffect(() => {
    //     if (isLoggedIn) {
    //         dispatch(getprofile());
    //     }
    // }, [dispatch])

    const location = useLocation();
    const navType = useNavigationType();
    useEffect(() => {
        if (navType !== "POP") {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }, [location]);
    return <>{children}</>;
}
export default SmoothScroll;